export default "__VITE_ASSET__OrjtXQIU__"